import React from 'react';
import { useInputContext } from './contexts/input-context';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { AsChildSlot } from '@wix/headless-utils/react';

interface FilesFileUploadProps {
  renderFile: (file: string) => React.ReactNode;
  className?: string;
  asChild?: boolean;
}

export const Files = React.forwardRef<HTMLDivElement, FilesFileUploadProps>(
  (props, ref) => {
    const { className, asChild, renderFile } = props;
    const { explanationText } = useFieldProps<PublicFileUploadProps>();
    const { files } = useInputContext();
    if (explanationText) {
      return;
    }

    return (
      <AsChildSlot ref={ref} asChild={asChild} className={className}>
        <div>{files.map((file) => renderFile(file))}</div>
      </AsChildSlot>
    );
  },
);

Files.displayName = 'FileUpload.Input.Files';
